import { ButtonV2 } from "../../../../Atoms/ButtonV2";
import { cn } from "../../../../../utils/cn";
import {
  ACTIVE_TENANT,
  TENANT_BG_LIGHT_CLASSES,
  TENANT_TEXT_CLASSES,
} from "../../../../../constants/tenant_colors";

interface IBatchSchedulingBannerProps {
  className?: string;
  onAccess: () => void;
}

export const BatchSchedulingBanner = ({
  className,
  onAccess,
}: IBatchSchedulingBannerProps) => {
  return (
    <div
      className={cn(
        "flex flex-col md:flex-row items-start md:items-center gap-6 rounded-[10px] py-8 px-4",
        TENANT_BG_LIGHT_CLASSES[ACTIVE_TENANT],
        "w-full",
        className,
      )}
    >
      <div className="bg-black/10 rounded-[10px] p-[5px] w-fit">
        <img src="/assets/svgs/icon-layers.svg" alt="ícone camadas" />
      </div>

      <div className={cn("flex-1", TENANT_TEXT_CLASSES[ACTIVE_TENANT])}>
        <h3 className="text-2xl md:text-[32px] md:leading-9 font-extrabold tracking-[0.03em]">
          Agendamento em lote
        </h3>
        <p className="text-sm leading-6">
          Importe uma planilha com as informações dos veículos e clientes para
          criar dezenas de agendamentos de uma só vez.
        </p>
      </div>

      <ButtonV2 className="w-full md:w-fit" onClick={onAccess}>
        Importar
        <img
          alt="seta para a direira"
          src="/assets/svgs/icon-arrow-forward.svg"
        />
      </ButtonV2>
    </div>
  );
};
